export default __webpack_public_path__ + "dee3e644bfc8437814da6a23f6651fe7.png";